import { render, staticRenderFns } from "./OpremaVozila.vue?vue&type=template&id=4a8aedce&scoped=true&"
import script from "./OpremaVozila.vue?vue&type=script&lang=ts&"
export * from "./OpremaVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8aedce",
  null
  
)

export default component.exports